<template>
  <transition
    v-if="doOptionsDisplay() || !isMobile"
    name="toggle-options-mobile"
    :class="{'toggle-options-mobile': isMobile}"
  >
    <section
      v-if="showOptions || !isMobile"
      :class="{'event-options': !isMobile, 'event-options-mobile': isMobile}">
      <b-modal
        ignore-enforce-focus-selector=".header"
        modal-class="padding-top_modal-list"
        hide-header
        hide-footer
        dialog-class="app__add-friend-modal"
        body-class="app__modal_body app__add-friend-modal_body"
        content-class="modal_content"
        id="change-event-currency">
        <change-event-currency-form/>
      </b-modal>
      <b-modal
        ignore-enforce-focus-selector=".header"
        modal-class="padding-top_modal-list"
        hide-header
        hide-footer
        dialog-class="app__add-friend-modal"
        body-class="modal_body"
        content-class="modal_content"
        id="change-event-families">
        <drag-change-event-families/>
      </b-modal>
      <b-modal
        ignore-enforce-focus-selector=".header"
        centered
        hide-footer
        hide-header
        dialog-class="events__delete-event-user-modal"
        body-class="events__delete-event-user-modal_body modal_body"
        content-class="modal_content"
        id="delete-event-user"
      >
        <delete-user-form/>
      </b-modal>
      <button
        v-if="isMobile"
        @click="$emit('toggleOptionsPanel')"
        class="operation-options-button">
        <font-awesome-icon icon="chevron-left" class="chevron-icon-left"/>
      </button>
      <button
        @click="confirmDeleteEvent"
        v-if="(user.user === (event && event.owner_id)) && !isEventQuasi"
        class="operation-options_delete-event">
        <b-icon-trash class="operation-options-button_delete-event"/>
      </button>
      <figure class="event-header">
        <div
          class="event-image"
        >
          <image-upload
            :disable-upload="(user.user !== (event && event.owner_id)) || isEventQuasi"
            @loadImage="loadImage"
            :value="eventImage"
            size="43px"
            type="sharp"
            class="event-image__image"
          />
          <transition name="form__error__fade">
            <p
              @click="imageErrorMessage = ''"
              v-if="imageErrorMessage"
              class="event-image__error-message"
            >
              {{ imageErrorMessage }}
            </p>
          </transition>
        </div>
        <figcaption
          v-if="isEventQuasi || (event && event.owner_id) !== user.user"
          class="event-header__title"
        >
          <span
            v-if="!eventName"
            class="event-header__label">
            {{ $t('eventOptions.eventName') }}
          </span>
          <span class="event-header__name">
            {{ eventName }}
          </span>
        </figcaption>
        <form
          @submit.prevent="saveEventName"
          v-else-if="!isEventQuasi && (event && event.owner_id) === user.user"
          class="event-header__title"
        >
          <app-input-small
            class="event-title-input"
            text-align="center"
            :default-text="eventName"
            :label="$t('eventOptions.eventName')"
            :error="eventNameTouched && !eventName.length"
            :larger="true"
            @input="changeEventName"
            :label-fade-on-input="true"
          />
          <transition
            name="saveEventName"
          >
            <button-app
              v-if="isEventNameSaveAvailable"
              class="change-event-name"
              color-scheme="gray"
              type="button"
              @clicked="saveEventName"
            >
              <AppLoader v-if="isEventNameBeingSaved" />
              <span v-else>{{ $t('CP.save') }}</span>
            </button-app>
          </transition>
        </form>
      </figure>
      <p class="human-items-title">
        {{ $t('eventOptions.eventParticipants') }}
      </p>
      <!--      <div-->
      <!--        v-if="eventsStatus === 'loading' || eventStatus === 'loading'"-->
      <!--        class="event-list-plug">-->
      <!--        <app-loader-->
      <!--          class="event-list-loader"-->
      <!--        />-->
      <!--      </div>-->
      <people-list
        class="people-list"
        :active-users="(event && event.active_users) || []"
        :owner-id="isEventQuasi ? null : (event && event.owner_id)"
        @deleteUser="deleteUser"
        @updateFamilies="updateFamilies"
        message="show money"
        :disable-focus="true"
        :users="event.contacts"
        :families="event.families"
        :family-owner-ids="familyOwnerIds"
        :currency="eventCurrency"
        :show-add-button="user.user === (event && event.owner_id)"
        :show-delete-button="!isEventQuasi"
        disable-delete-button-if-access-denied
        :add-link-to-users="true"
      />
      <add-human-button
        v-if="(user.user === (event && event.owner_id)) && !isEventQuasi"
        variant="edit"
        :text="$t('CP.familiesSettings')"
        :show-text="true"
        @clicked="$bvModal.show('change-event-families')"
      />
<!--      <button-app-->
<!--        v-if="event.used_currencies"-->
<!--        class="change-currency"-->
<!--        color-scheme="gray"-->
<!--        type="button"-->
<!--        :disabled="(event && event.used_currencies && (!event.used_currencies.length-->
<!--          || !(event.used_currencies.length - 1)))-->
<!--            && !(event.used_currencies && !!event.used_currencies.length-->
<!--            && !event.used_currencies.includes(user.currency))"-->
<!--        @clicked="$bvModal.show('change-event-currency')"-->
<!--      >-->
<!--        {{ $t('CP.changeCurrency') }}-->
<!--      </button-app>-->
    </section>
  </transition>
</template>

<script>
/* eslint-disable vue/no-side-effects-in-computed-properties */

import { mapState } from 'vuex';
import {
  DELETE_EVENT_REQUEST,
  SET_USER_TO_DELETE,
  UPDATE_EVENT_REQUEST,
} from '@/store/events/types';
import { SET_CONFIRM_MODAL_INFO, SET_CROPPER_INFO } from '@/store/operations/types';
import ButtonApp from '../../components/Button/ButtonApp';
import PeopleList from '../../components/PeopleList/PeopleList';
import ImageUpload from '../../components/ImageUpload/ImageUpload';
import DeleteUserForm from '../../forms/DeleteUserForm/DeleteUserForm';
import ChangeEventCurrencyForm from '../../forms/ChangeEventCurrencyForm/ChangeEventCurrencyForm';
import AddHumanButton from '../../components/AddHumanButton/AddHumanButton';
import DragChangeEventFamilies from '../../forms/DragChangeEventFamilies/DragChangeEventFamilies';
import AppInputSmall from '../../components/AppInputSmall/AppInputSmall';
import AppLoader from '../../components/AppLoader/AppLoader';

export default {
  name: 'EventOptions',
  components: {
    AppInputSmall,
    DragChangeEventFamilies,
    AddHumanButton,
    ImageUpload,
    PeopleList,
    ButtonApp,
    DeleteUserForm,
    ChangeEventCurrencyForm,
    AppLoader,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
    showOptions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      eventName: '',
      eventNameTouched: false,
      isEventNameSaveAvailable: false,
      isEventNameBeingSaved: false,
      imageErrorMessage: '',
    };
  },
  mounted() {
    this.eventName = (this.event && this.event.quasi_event_name) || (this.event && this.event.event_name) || '';
  },
  computed: {
    ...mapState({
      event: (state) => state.events.event,
      events: (state) => state.events.events,
      user: (state) => state.user.user,
      eventsStatus: (state) => state.events.eventsStatus,
      eventStatus: (state) => state.events.eventStatus,
      eventCurrency: (state) => state.events.eventCurrency || state.user.user.currency,
    }),
    isEventQuasi() {
      return this.event && !this.event.event_name;
    },
    familyOwnerIds() {
      return this.event.families && this.event.families.map((family) => family.head);
    },
    eventImage() {
      if (this.event && this.user) {
        if (this.event.image_url) {
          return this.event.image_url;
        }
        if (!this.event.event_name && this.event.contacts) {
          const quasiUser = this.event.contacts
            .find((contact) => contact.uid !== this.user.user).avatar_url;
          if (quasiUser) {
            return quasiUser;
          }
        }
      }
      return '';
    },
  },
  watch: {
    event(nextEvent) {
      if (nextEvent && this.user) {
        if (nextEvent.event_name) {
          this.isEventNameChangeable = true;
          this.eventName = nextEvent.event_name;
        } else if (nextEvent.contacts) {
          const quasiUser = nextEvent.contacts
            .find((contact) => contact.uid !== this.user.user);
          const quasiUserName = this.$getUserName(quasiUser);
          if (quasiUserName) {
            this.isEventNameChangeable = false;
            this.eventName = quasiUserName;
          }
        } else {
          this.eventName = '';
        }
      }
    },
  },
  methods: {
    changeEventName(eventName) {
      this.eventName = eventName;
      if (!!this.eventName.length && (this.event.event_name !== this.eventName)) {
        this.isEventNameSaveAvailable = true;
      } else {
        this.isEventNameSaveAvailable = false;
      }
    },
    async saveEventName() {
      this.isEventNameBeingSaved = true;
      await this.$store.dispatch(UPDATE_EVENT_REQUEST, {
        id: this.event.id,
        data: {
          event_name: this.eventName,
        },
      });
      this.isEventNameSaveAvailable = false;
      this.isEventNameBeingSaved = false;
    },
    updateFamilies(families) {
      this.$store.dispatch(UPDATE_EVENT_REQUEST, {
        id: this.event.id,
        data: {
          families,
        },
      });
    },
    confirmDeleteEvent() {
      this.$store.commit(SET_CONFIRM_MODAL_INFO, {
        question: this.$t('CP.confirmDeleteEvent'),
        acceptanceTitle: this.$t('CP.yesDelete'),
        denialTitle: this.$t('CP.cancel'),
        submitHandler: this.deleteEvent.bind(this),
      });
      this.$bvModal.show('app-confirm-modal');
    },
    async deleteEvent() {
      try {
        const eventDelId = this.event.id;
        let nextEventId = this.events[0] && this.events[0].id;
        if (nextEventId === eventDelId) {
          nextEventId = this.events[1] && this.events[1].id;
        }
        await this.$store.dispatch(DELETE_EVENT_REQUEST, { id: eventDelId });
        if (nextEventId) {
          this.$router.push({
            name: 'TransactionsPage',
            params: {
              id: nextEventId.toString(),
            },
          });
        } else {
          await this.$router.push('/events');
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('error in delete events: ', e);
      }
    },
    doOptionsDisplay() {
      return (this.isMobile
        && (this.$route.fullPath
          .match(/\/events\/\d+(\/transactions|debts|my-share)?/)))
        || !this.isMobile;
    },
    deleteUser(user) {
      this.$store.commit(SET_USER_TO_DELETE, user.phone);
      this.$bvModal.show('delete-event-user');
    },
    async loadImage(file) {
      try {
        const reader = new FileReader();
        reader.onload = async () => {
          const img = await new Image();
          img.src = reader.result.toString();
          img.onload = () => {
            let imageError = false;
            if (img.width < 70 || img.width > 10000
              || img.height < 70 || img.height > 10000 || file.size > 5242880) {
              this.imageErrorMessage = this.$t('CP.errorOutOfBoundsPictureCrop');
              // eslint-disable-next-line no-console
              console.log('image size should be between 70x70 and 10000x10000 px',
                'current size: ', img.width, img.height);
              imageError = true;
            }
            if (imageError) return;
            this.$store.commit(SET_CROPPER_INFO, {
              src: img.src,
              dispatchAction: UPDATE_EVENT_REQUEST,
              dispatchData: {
                id: this.event.id,
                data: {
                  image_url: reader.result.split(',')[1],
                },
              },
              reloadEvents: true,
            });
            this.$bvModal.show('cropper');
          };
        };
        await reader.readAsDataURL(file);
        return null;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e.message);
        throw new Error(e.message);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.event-options {
  word-break: break-word;
  position: relative;
  flex: 0 1 329px;
  padding: 32px;
  background-color: #FFFFFF;
  /*min-height: 100%;*/
  height: 100%;
  overflow-y: auto;
}

.chevron-icon-left {
  color: var(--btn-primary);
  width: 10px;
  height: 18px;
  vertical-align: middle;
}

.event-image {
  position: relative;
  width: 130px;
  height: 130px;
  margin: 0 auto 24px;
}

.event-image__image {
  width: 130px;
  height: 130px;
  border-radius: 50%;
  @media screen and (max-width: $breakpoint-sm) {
    margin-left: 0;
  }
}

.event-image__error-message {
  position: fixed;
  right: 30px;
  top: 30px;
  cursor: pointer;
  z-index: 1000;
  color: var(--error-red);
  padding: 20px;
  background: #ef9a9a;
  border-radius: 4px;
  text-align: center;
  font-size: 1rem;
  letter-spacing: .5px;
  line-height: 20px;
  margin-top: 20px;
}

.event-image__edit-icon {
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 50%;
  width: 33px;
  height: 33px;
}

.event-header__title {
  word-break: break-word;
  margin: 0 0 32px;
  display: flex;
  flex-wrap: wrap;
}

.event-title-input {
  width: 100%;
}

.event-header__label {
  flex: 0 1 100%;
  font-size: 12px;
  opacity: 0.4;
}

.event-header__name {
  flex: 0 1 100%;
  font-size: 16px;
  padding: 5px 0;
  border-bottom: 1px solid rgba(72, 82, 140, 0.15);
}

.human-items-title {
  text-align: left;
}

.people-list {
  margin-bottom: 0;
}

.operation-options-button {
  position: absolute;
  top: 24px;
  left: 24px;
  background-color: #FFFFFF;
  border: none;
  outline: none;
  width: 23px;
  height: 23px;
  box-sizing: border-box;
  padding: 0;
  border-radius: 50%;
}

.operation-options_delete-event {
  position: absolute;
  top: 24px;
  right: 24px;
  background-color: #FFFFFF;
  border: none;
  outline: none;
  width: 23px;
  height: 23px;
  box-sizing: border-box;
  padding: 0;
  border-radius: 50%;
}

.operation-options-button_delete-event {
  width: 20px;
  height: 20px;
  color: var(--error-red);
}

.change-currency, .change-event-name {
  font-size: 13px;
  height: 38px;
}

.event-list-plug {
  /*flex: 0 1 508px;*/
}

.event-list-loader {
  margin: 8vh auto 12vh;
}
.saveEventName-enter-active, .saveEventName-leave-active {
  transition: height .4s, opacity .2s, margin .4s;
  content: "";
}

.saveEventName-enter, .saveEventName-leave-to {
  opacity: 0;
  height: 0;
  margin: 0;
}

//Classes for an animation of going into options
@media screen and (max-width: $breakpoint-sm) {
  .event-options {
    height: unset;
  }
  .event-options-mobile {
    position: fixed;
    top: 45px;
    left: 0;
    right: 0;
    height: 100%;
    overflow-y: auto;
    padding: 32px;
    padding-bottom: 15%;
    background-color: #FFFFFF;
  }
  .toggle-options-mobile-enter-active {
    height: 100%;
    transition: all .3s ease-out;
  }
  .toggle-options-mobile-leave-active {
    height: 100%;
    transition: all .3s ease-in;
  }
  .toggle-options-mobile-enter, .toggle-options-mobile-leave-to {
    height: 100%;
    transform: translateX(100vw);
  }
}
</style>
